import React from "react";
import ReactPaginate from "react-paginate";

const PaginateComponent = ({ totalPages, handlePageClick, currentPage }) => {
  return (
    <div className="row justify-content-center mt-4">
      <div className="col-12">
        <ReactPaginate
          previousLabel={"← Previous"}
          nextLabel={"Next →"}
          breakLabel={"..."}
          pageCount={totalPages}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          forcePage={currentPage}
          onPageChange={handlePageClick}
          containerClassName="pagination pagination-sm flex-wrap justify-content-center"
          activeClassName="active"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakClassName="page-item"
          breakLinkClassName="page-link"
        />
      </div>
    </div>
  );
};

export default PaginateComponent;
